import tippy from 'tippy.js'

function showMessage(
  targetElement,
  message,
  duration = 1000
) {
  tippy(targetElement, {
    content: message,
    showOnCreate: true,
    delay: [null, duration],
    // trigger: 'manual',
    onHidden: (instance) => instance.destroy(),
  })
}

export function initShare(button) {
  function showError() {
    showMessage(button, 'Couldn\'t copy link to clipboard')
  }
  button.addEventListener('click', () => {
    try {
      if ('share' in window.navigator) {
        window.navigator
          .share({
            url: window.location.href,
            title: document.title,
          })
          .catch(showError)
      } else {
        window.navigator.clipboard
          .writeText(window.location.href)
          .then(() => showMessage(button, 'Copied to clipboard'))
          .catch(showError)
      }
    } catch (e) {
      showError()
    }
  })
}
